import dynamic from 'next/dynamic';

const NewsletterTeaser = dynamic(() =>
  import('@components/organisms/Newsletter/NewsletterTeaser').then((module) => module.NewsletterTeaser),
);

// TV-MEDIA intentionally replaces inline signup with the discovery teaser.
// Keep accepting existing PCE data; shared CMS fields and other portals are unchanged.
export default function PageContentElementNewsletterBoxes(_element, _index, data) {
  return <NewsletterTeaser hasBackground={!data?.power_branding} />;
}
